<template>
  <v-col cols="12" class="pb-0 task-list">
    <v-row>
      <v-col align-self="center">
        <v-row no-gutters>
          <h4 class="greyDark--text mb-0 mt-1 mr-1">{{ headerTitle }}</h4>
          <v-menu
              v-model="menu"
              offset-x
              :close-on-content-click="false"
              min-width="400"
          >
            <template v-slot:activator="{ on: menu}">
              <v-tooltip bottom>
                <template v-slot:activator="{ on:tooltip}">
                  <v-btn icon v-on="{...menu, ...tooltip}">
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                </template>
                <span>Filter</span>
              </v-tooltip>
            </template>

            <v-card class="pa-5">
              <h6 class="greyDark--text mb-0 font-weight-bold">{{ $t('components:common.filter-by') }}</h6>

              <v-text-field
                  v-model="search"
                  append-icon="search"
                  :value="computedSearch"
                  :label="$t('components:common.search')"
                  single-line
                  hide-details
                  clearable
              />

              <v-radio-group v-model="filterBy">
                <v-radio
                    v-for="(f, i) in filter"
                    :key="i"
                    :label="f.label"
                    :value="f.value"></v-radio>
              </v-radio-group>

              <h6 class="greyDark--text mb-0 font-weight-bold">{{ $t('components:task-list.from') }}</h6>
              <v-row>
                <v-col>
                  <DateField
                      ref="periodFrom"
                      is-clearable
                      :label="$t('components:task-list.from')"
                      @update="(v) => (periodFilter.periodFrom = v)"
                  />
                </v-col>
                <v-col>
                  <DateField
                      ref="periodUntil"
                      is-clearable
                      :label="$t('components:task-list.until')"
                      @update="(v) => (periodFilter.periodUntil = v)"
                  />
                </v-col>
              </v-row>

              <h6 class="greyDark--text mb-0 font-weight-bold">{{ $t('components:common.sort-by') }}</h6>

              <v-row no-gutters justify="space-between">
                <v-col cols="5">
                  <v-radio-group v-model="sortBy">
                    <v-radio
                        v-for="(sort, i) in sorts"
                        :key="i"
                        :label="sort.label"
                        :value="sort.value"></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="5">
                  <v-radio-group v-model="sortDesc">
                    <v-radio color="secondary" :label="$t('components:common.descending')" :value="false"></v-radio>
                    <v-radio color="secondary" :label="$t('components:common.ascending')" :value="true"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="menu = false"
                >
                  {{ $t('buttons:close') }}
                </v-btn>
              </v-row>

            </v-card>
          </v-menu>

          <v-menu
              v-model="usersMenu"
              min-width="450"
              v-if="users && users.length > 0"
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="user-list ml-3" v-on="on" v-bind="attrs">
                <v-avatar size="30" v-for="user in users.slice(0, 3)" :key="user.id">
                  <v-img
                      src="@/assets/default_profile_pic.png"
                  ></v-img>
                </v-avatar>
              </div>
            </template>

            <v-card>
              <v-card-title><h6 class="greyDark--text mb-0 font-weight-bold">{{ $t('components:task-list.participates') }}</h6></v-card-title>
              <v-card-text>
                <v-list>
                  <v-list-item v-for="user in users" :key="user.id">
                    <v-row align="center">
                      <v-col>
                        <v-avatar size="40">
                          <v-img
                              src="@/assets/default_profile_pic.png"
                          ></v-img>
                        </v-avatar>
                        <span class="ml-2 text-body-1">{{ user.name }}</span>
                      </v-col>
                      <v-col cols="3" class="text-right">
                        <v-btn color="primary" icon @click="callPhoneNumber(user.phone)">
                          <v-icon>phone</v-icon>
                        </v-btn>
                        <v-btn color="primary" icon @click="writeEMail(user.email)">
                          <v-icon>email</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-row>
      </v-col>
      <v-col class="text-right">
        <BaseButton
            v-show="!hideHeaderBtn"
            icon="add"
            color="primary"
            :btnText="headerBtnText"
            @clickedButton="$emit('clickedHeaderBtn')"
        />

        <v-menu offset-y left v-if="hideHeaderBtn && showHeaderMenu">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="grey">more_vert</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item-group>
              <v-list-item @click="$emit('menuItemClicked1')">
                {{ menuItemText1}}
              </v-list-item>

              <v-list-item @click="$emit('menuItemClicked2')">
                {{ menuItemText2}}
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
 
    <div v-if="data && data.length > 0">
      <TaskCard         
          v-for="(task, i) in data" :key="i"         
          class="mb-2 pointer"
          :taskName="getTaskName(task)"
          :additionalNames="getAdditionalName(task)"
          :additional-name2-as-btn="enableFacilityNameBtn"
          :taskStatus="task.taskStatus"
          :username="task.assignedToName"
          :userId="task.assignedToId"
          :period="(task.startDate && task.endDate) ? task.startDate + ' - ' + task.endDate : ''"
          :timestamp="(task.finishedOn && !task.isJob) ? task.finishedOn : ''"
          :checkIn="task.checkIn"
          @click.native.stop="$emit('clickedCard', task)"
          @acceptTask="$emit('acceptTask', task)"
          @declineTask="$emit('declineTask', task)"
          @startTask="$emit('startTask', task)"
          :hideUser="computedHideUser && isHideUser(task)"
          :accepted="getAccepted(task)"
          :can-accept-job-invitation="task.canAcceptJobInvitation"
          @clickedAdditional2="$emit('clickedFacilityName', task.facilityId)"
      />

      <v-pagination
          class="custom-pagination"
          color="primary"
          v-model="options.page"
          :length="totalPages"
          :total-visible="7"
      ></v-pagination>
    </div>
    <h5 v-else-if="data && data.length == 0" class="greyTint--text mb-0 mt-5 text-center">{{ $t('common:no-data-found') }}</h5>
  </v-col>
</template>
<script>
import BaseButton from '@/modules/core/components/Base/BaseButton';
import DateField from '@/modules/core/components/DateField';
import {Role} from '@/modules/core/data/roles';

export default {
  name: 'TaskList',
  components: {
    DateField,
    BaseButton,
    TaskCard: () => import('@/modules/book/components/TaskCard/TaskCard')
  },
  props: {
    headerTitle: String, // Title for taskList
    hideHeaderBtn: Boolean, // To hide right header btn
    headerBtnText: String, // Text for right button above list
    sorts: Array, // sort values
    filter: Array, // filter values
    defaultDesc: Boolean,
    defaultSortBy: String,
    defaultFilterBy: String,
    hideUser: Boolean,
    showHeaderMenu: Boolean,
    menuItemText1: String, // Text for menu item 1
    menuItemText2: String, // ^ menu item 2
    enableFacilityNameBtn: Boolean
  },
  data() {
    return {
      menu: null,
      usersMenu: null,

      search: '',
      options: {
        sortBy: ['processName'],
        sortDesc: [false],
        itemsPerPage: 5,
        page: 1
      },
      sortDesc: false,
      sortBy: null,
      data: [],
      users: [],
      totalPages: null,
      searchTimer: null,
      filterBy: this.defaultFilterBy,
      periodFilter: {
        periodFrom: '',
        periodUntil: ''
      }
    }
  },
  computed: {
    // hide user profile picture if either
    // hideUser is set or the users array is empty
    computedHideUser() {
      if (this.hideUser) {
        return true;
      } else {
        if (this.users && Object.keys(this.users).length > 0) {
          return false;
        } else {
          return true;
        }
      }
    },
    computedSearch: {
      get() {
        if (this.search) {
          this.$emit('cacheCommit', this.search);
          return this.search
        }
        this.$emit('cacheCommit', null);
        return null
      },
      set(value) {
        this.search = value;
      }
    },
    currentLang() {
      return this.$store.state.translation.language;
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Admin);
      }
      return false;
    },
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {

    if(this.cachedSearch) {
      this.search = this.cachedSearch;
    }

    if(this.defaultDesc) {
      this.sortDesc = this.defaultDesc;
    }

    if(this.defaultSortBy) {
      this.sortBy = this.defaultSortBy;
    }
  },
  watch: {
    search() {
      this.computedSearch = this.search
      //use timer function to wait for user to finish until we search
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.options.page = 1; //reset the page back to 1 on search, otherwise we can land on an empty page
        this.callListUpdate();
      }, 500);
    },
    //by deep watching the table options, we can automatically call an update whenever sort/page changes
    options: {
      handler() {
        this.callListUpdate();
      },
      deep: true,
      immediate: true //with this it will trigger on initialization -> we don't have to load on mount
    },
    sortDesc() {
      this.options.sortDesc[0] = this.sortDesc;
      this.options.page = 1;
      this.callListUpdate();
    },

    sortBy() {
      this.options.sortBy[0] = this.sortBy;
      this.options.page = 1;
      this.callListUpdate();
    },

    filterBy() {
      this.options.page = 1;
      this.callListUpdate();
    },

    'periodFilter.periodFrom'(value) {
      this.options.page = 1;
      this.callListUpdate();

      if (value) {
        this.$refs.periodUntil.setMinDate(value);
      } else {
        this.$refs.periodUntil.resetMinDate();
      }
    },

    'periodFilter.periodUntil'(value) {
      this.options.page = 1;
      this.callListUpdate();

      if (value) {
        this.$refs.periodFrom.setMaxDate(value)
      } else {
        this.$refs.periodFrom.resetMaxDate();
      }
    }
  },
  methods: {
    getAccepted(task) {
      if (task.isJob) {
        return task.accepted;

        // if process result
      } else if (!task.isJob && !task.isRoleInvitation) {
        return true;

        // if roleInvitation
      } else {
        return false;
      }
    },

    callListUpdate() {
      clearTimeout(this.tableUpdateTimer);
      this.tableUpdateTimer = setTimeout( () => {
        if (!this.periodFilter) {
          this.periodFilter.periodFrom = '';
          this.periodFilter.periodUntil = '';
        }
        this.$emit('updateData', this.options, this.search, this.filterBy, this.periodFilter);
      },50);
    },
    fillList(data) {
      if (data == null) {
        this.data = [];
      } else {
        this.data = data.content;
      }
      this.totalPages = data.totalPages
    },

    // open new window to call user by phone number
    callPhoneNumber(phoneNumber) {
      window.open('tel:' + phoneNumber)
    },

    writeEMail(email) {
      window.open('mailto:' + email)
    },

    getTaskName(task) {
      if(task.isRoleInvitation) {
        return this.$t('components:task-card.states.role-invitation') + ': ' + task.workerRoleName
      } else {
        return task.processName;
      }
    },
    getAdditionalName(task) {
      return [
        { name: task.buildingName, asButton: false },
        { name: task.facilityName, asButton: this.enableFacilityNameBtn }
      ];
    },
    isHideUser(task) {
      return !(this.isAdmin && task.assignedToName);
    }
  }
}
</script>
<style src="./TaskList.scss" lang="scss"/>